import React, { PropTypes, Component } from 'react';
import classNames from 'classnames';
import { Units, Colors } from 'Css';
import Tag from './Tag';

const ENTER = 13;
const BACKSPACE = 8;

const css = oxygenCss({
  tagsContainer: {
    display: 'inline-block',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    borderRadius: 2.2,
    fontWeight: 100,
    border: 'solid 2px #EEE',
    padding: `0 ${Units.base / 2}px`,
    '&fullWidth': {
      display: 'block'
    },
    '&dark': {
      border: 'solid 2px #101010',
      backgroundColor: Colors.darkBlack,
      ' input': {
        '::placeholder': {
          color: Colors.text.Light.disabled
        },
        color: Colors.text.Light.default
      }
    },
    '&padded': {
      padding: Units.base
    },
    ' input': {
      height: 40,
      lineHeight: '40px',
      border: 'none',
      outline: 'none',
      background: 'transparent',
      display: 'inline-block',
      minWidth: Units.keyline * 2,
      padding: Units.base / 4,
      verticalAlign: 'top',
      textAlign: 'left',
      boxSizing: 'border-box',
      '::placeholder': {
        color: Colors.text.Dark.disabled
      }
    }
  },
  inputWrapper: {
    display: 'inline-block',
    verticalAlign: 'middle',
    height: 40,
    lineHeight: '40px'
  }
});

export default class TagSelector extends Component {
  static propTypes = {
    tags: PropTypes.object,
    onAddTag: PropTypes.func,
    onRemoveTag: PropTypes.func,
    placeholder: PropTypes.string,
    fullWidth: PropTypes.bool,
    padded: PropTypes.bool,
    dark: PropTypes.bool
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static defaultProps = {
    fullWidth: false,
    tags: {}
  };

  addedTags = Object.keys(this.props.tags);

  handleKey = event => {
    const { keyCode } = event;
    if (keyCode === ENTER) {
      this.addTag();
    } else if (
      keyCode === BACKSPACE &&
      !this._input.value &&
      this.addedTags.length > 0
    ) {
      const toDelete = this.addedTags.pop();
      this.removeTag(toDelete);
    }
  };

  addTag = () => {
    const { onAddTag } = this.props;
    const tagName = this._input.value.trim();
    if (tagName && tagName !== '') {
      this.addedTags.push(tagName);
      onAddTag && onAddTag(tagName);
      this._input.value = null;
    }
  };

  removeTag = tagName => {
    const { onRemoveTag } = this.props;
    this.addedTags = this.addedTags.filter(tag => tag !== tagName);
    onRemoveTag && onRemoveTag(tagName);
  };

  render() {
    const { tags, fullWidth, dark, padded, placeholder } = this.props;
    const { getIntlMessage } = this.context;
    const classes = classNames(css.tagsContainer, {
      [css.dark]: dark,
      [css.padded]: padded,
      [css.fullWidth]: fullWidth
    });
    const placeholderText =
      typeof placeholder === 'undefined'
        ? getIntlMessage('tag.name')
        : placeholder;
    return (
      <div className={classes} onTouchTap={() => this._input.focus()}>
        {tags &&
          Object.keys(tags).map(tagName => {
            if (tags[tagName]) {
              return (
                <Tag
                  dark={dark}
                  onRemove={this.removeTag}
                  key={tagName}
                  tag={tagName}
                />
              );
            }
            return null;
          })}
        <div className={css.inputWrapper}>
          <input
            ref={_input => (this._input = _input)}
            className={css.input}
            type="text"
            placeholder={placeholderText}
            onKeyUp={this.handleKey}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Tags/TagSelector.js